import { WATCHMEN_RESOURCES, ACCESS_TYPES } from "../constants";
import _ from "lodash";

export class RBACUtils {
  static getPermission(
    context: string[] | string,
    resource: string,
    access: string
  ): string[] {
    if (!Array.isArray(context)) context = [context];
    return context.map((ctx) => `${ctx}:${resource}:${access}`);
  }

  static getReadPermission(
    context: string[] | string,
    resource: string
  ): string[] {
    return RBACUtils.getPermission(context, resource, ACCESS_TYPES.READ);
  }

  static getCreatePermission(
    context: string[] | string,
    resource: string
  ): string[] {
    return RBACUtils.getPermission(context, resource, ACCESS_TYPES.CREATE);
  }

  static getUpdatePermission(
    context: string[] | string,
    resource: string
  ): string[] {
    return RBACUtils.getPermission(context, resource, ACCESS_TYPES.UPDATE);
  }

  static getDeletePermission(
    context: string[] | string,
    resource: string
  ): string[] {
    return RBACUtils.getPermission(context, resource, ACCESS_TYPES.DELETE);
  }

  static getAccessPermissions(
    context: string,
    resource: WATCHMEN_RESOURCES,
    access = ACCESS_TYPES.READ
  ): any {
    if (context) {
      return () => {
        if (context) {
          const permissionString = `${context}:${resource}:${access}`;
          return [permissionString];
        }
        return [];
      };
    }
  }

  static hasPermissionForAccessType(
    accessType = ACCESS_TYPES.READ,
    userPermissions: any,
    context: string,
    resource: WATCHMEN_RESOURCES
  ): boolean {
    const permissions =
      userPermissions &&
      _.get(userPermissions, [context, resource], []).filter(
        (access: string) => access === accessType
      );
    return !_.isEmpty(permissions);
  }
}
